export default __webpack_public_path__ + "static/media/nosotros1.f8348bbb.jpeg";